import { useT } from '../../i18n'
import styles from '../note.module.css'

/**
 * Tells internal users where internal accounts come from.
 *
 * This portal deliberately cannot create them: an `internal` account reads
 * EVERY biller's payment data, so letting one internal user mint another is a
 * privilege-escalation path that nothing in the BRD or PRD asked for. The
 * decision is sound; leaving people to discover it by finding no button was
 * not. An operator who needs a colleague onboarded should not have to guess
 * that the answer is a different system.
 *
 * Expanded by default — the admins who need it arrive at this screen to
 * onboard someone and should not have to notice a chevron first. It remains a
 * <details> so anyone tired of it can fold it away.
 *
 * No link to Keycloak. `/bff/config` deliberately carries no upstream URLs,
 * and adding one just for a hyperlink would trade a real boundary for a
 * convenience. The steps name the realm instead, which is what a Keycloak
 * admin needs anyway.
 */
export function InternalUsersNote() {
  const t = useT()
  const steps = [
    t('users.internalNote.step1'),
    t('users.internalNote.step2'),
    t('users.internalNote.step3'),
    t('users.internalNote.step4'),
    t('users.internalNote.step5'),
    t('users.internalNote.step6'),
  ]
  return (
    <details className={styles.note} open>
      <summary className={styles.summary}>{t('users.internalNote.title')}</summary>
      <div className={styles.body}>
        <p>{t('users.internalNote.why')}</p>
        <p className={styles.who}>{t('users.internalNote.who')}</p>
        <ol className={styles.steps}>
          {steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
        <p className={styles.caution}>{t('users.internalNote.caution')}</p>
        <p>{t('users.internalNote.deactivate')}</p>
      </div>
    </details>
  )
}
